import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import NavBar from './components/NavBar';
import HeroVideo from './components/HeroVideo';
import WorkSection from './components/WorkSection';
import About from './pages/About';
import Contact from './pages/Contact';
import Footer from './pages/Footer';

function App() {
  return (
    <Router>
      <NavBar />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <HeroVideo />
              <main>
                <About />
              </main>
              <WorkSection />
              <Contact />
            </>
          }
        />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;
